import { AxiosError, isAxiosError } from 'axios';

interface IUpdateUserApiResponseData {
  message?: string;
  error?: string;
  data?: { message?: string; error?: string };
}

const firstString = (...values: Array<string | undefined>): string | undefined =>
  values.find((v): v is string => typeof v === 'string' && v.trim().length > 0);

export class UpdateUserApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'UpdateUserApiError';
  }

  static fromAxiosError(error: unknown): UpdateUserApiError | null {
    if (!isAxiosError(error)) {
      return null;
    }

    const axiosError = error as AxiosError<IUpdateUserApiResponseData>;
    const data = axiosError.response?.data;
    const message = firstString(
      data?.message,
      data?.error,
      data?.data?.message,
      data?.data?.error,
    );

    return message ? new UpdateUserApiError(message) : null;
  }
}
